export class UnitOfMeasureModel {
    allowEdit: boolean;
    defaultEntityId: number;
    id: number;
    name: string;
    show: boolean;
    type: number;
}
